import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import TaxInvoice from "./taxInvoice/TaxInvoice";
import Receivables from "./receivables/Receivables";
import PcsDetail from "../purchase/pcs/detail/PcsDetail";
import PcsList from "../purchase/pcs/list/PcsList";
import PcsCreate from "../purchase/pcs/create/PcsCreate";
import OrdersList from "./orders/list/OrdersList";
import OrdersCreate from "./orders/create/OrdersCreate";
import OrdersDetail from "./orders/detail/OrdersDetail";
import DeadlineList from "./deadline/list/DeadlineList";

export default function Orders() {
    const { key } = useLocation()

    return <Routes>
        <Route key={key} path={"orderRequest/list"} element={<PcsList isOrderRequest />} />
        <Route key={key} path={"orderRequest/detail/:id"} element={<PcsDetail isOrderRequest />} />
        <Route key={key} path={"orderRequest/create"} element={<PcsCreate isOrderRequest />} />
        <Route key={key} path={"orders/list"} element={<OrdersList />} />
        <Route key={key} path={"orders/detail/:id"} element={<OrdersDetail />} />
        <Route key={key} path={"orders/create"} element={<OrdersCreate />} />
        {/*<Route key={key} path={"shipment/list"} element={<></>}/>*/}
        {/*<Route key={key} path={"shipment/detail/:id"} element={<></>}/>*/}
        <Route key={key} path={"deadline/list"} element={<DeadlineList />} />
        <Route key={key} path={"deadline/detail/:id"} element={<OrdersDetail isDeadline />} />
        <Route key={key} path={"invoice/list"} element={<TaxInvoice />} />
        <Route key={key} path={"invoice/detail/:id"} element={<></>} />
        <Route key={key} path={"receivables/list"} element={<Receivables />} />
        <Route key={key} path={"receivables/detail/:id"} element={<></>} />
        <Route key={key} path={"*"} element={<Navigate to={"/not_found"} />} />
    </Routes>
}